export const GET_ALL_DOGS = "GET_ALL_DOGS";
export const GET_ALL_TEMPS = "GET_ALL_TEMPS";
export const GET_DOGS_BY_NAME = "GET_DOGS_BY_NAME";
export const FILTER_DOGS = "FILTER_DOGS";
export const RESET_SHOW_DOGS = "RESET_SHOW_DOGS";
export const CHANGE_LENGUAGE = "CHANGE_LENGUAGE";


